import { Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss'],
    standalone: false
})
export class VideoPlayerComponent {

  sanitizedHTML:SafeHtml='';
  videoURL:string=""
  isPageFullscreen = false;

  @ViewChild('playerHost') private playerHost?: ElementRef<HTMLElement>;

  constructor(public dialogRef: MatDialogRef<VideoPlayerComponent>,
    @Inject(MAT_DIALOG_DATA) public data:{vimeoVideoId:string,title:string},
    private sanitizer: DomSanitizer)
    { }

  ngOnInit()
  {
    const safeTitle = (this.data.title || 'Video').replace(/"/g, '&quot;');
    // background=0 ensures normal controls (background=1 would hide chrome). Vimeo hides volume UI when embed width < ~375px.
    this.videoURL =
      '<div class="vimeo-responsive">' +
      '<iframe src="https://player.vimeo.com/video/' +
      this.data.vimeoVideoId +
      '?badge=0&amp;background=0&amp;autopause=0&amp;controls=true&amp;playsinline=1&amp;player_id=0&amp;app_id=58479" ' +
      'frameborder="0" allowfullscreen ' +
      'allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" ' +
      'style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" title="' +
      safeTitle +
      '"></iframe></div>';
    this.sanitizedHTML = this.sanitizer.bypassSecurityTrustHtml(this.videoURL)
  }

  @HostListener('document:fullscreenchange')
  onFullscreenChange(): void {
    const el = this.playerHost?.nativeElement;
    this.isPageFullscreen = !!document.fullscreenElement && document.fullscreenElement === el;
  }

  toggleBrowserFullscreen(): void {
    const el = this.playerHost?.nativeElement;
    if (!el) {
      return;
    }
    if (document.fullscreenElement === el) {
      void document.exitFullscreen?.();
      return;
    }
    const req = el.requestFullscreen ?? (el as unknown as HTMLElement & { webkitRequestFullscreen(): Promise<void> }).webkitRequestFullscreen;
    if (typeof req === 'function') {
      void req.call(el);
    }
  }
}
